import { useBrandAssets } from "./BrandProvider";
import type { BrandMarkProps } from "./types";

// marks.tsx — the semantic brand marks a component reaches for.
//
// A feature component asks for the CURRENCY icon or the LOGO; it never names
// SmartMarket's spark or RichPoll's coin, and never imports an asset file. That
// indirection is the whole reason switching brands needs no edits below this
// layer. Each mark forwards className/style straight through, so sizing and
// placement stay with the call site exactly as before.

/** The unit glyph that leads a money figure. Picture only — never a value. */
export function CurrencyIcon(props: BrandMarkProps) {
  const { currencyIcon: Icon } = useBrandAssets();
  return <Icon {...props} />;
}

/** The reward / brand glyph used inline in chrome and on the auth screens. */
export function SparkIcon(props: BrandMarkProps) {
  const { sparkIcon: Icon } = useBrandAssets();
  return <Icon {...props} />;
}

/** Horizontal lockup. */
export function BrandLogoWordmark(props: BrandMarkProps) {
  const { logoWordmark: Logo } = useBrandAssets();
  return <Logo {...props} />;
}

/** Compact vertical lockup. */
export function BrandLogoStacked(props: BrandMarkProps) {
  const { logoStacked: Logo } = useBrandAssets();
  return <Logo {...props} />;
}

/** Square icon-only mark. */
export function BrandLogoMark(props: BrandMarkProps) {
  const { logoMark: Logo } = useBrandAssets();
  return <Logo {...props} />;
}
